import { Jurisdiction } from 'briefpoint-client/models/Jurisdiction';
import { useEffect, useState } from 'react';
import { useJurisdictionApi } from './useApi';

type UseJurisdictionsType = Jurisdiction[] | undefined;
export default function useJurisdictions(): UseJurisdictionsType {
  const [jurisdictions, setJurisdictions] = useState<Jurisdiction[]>();
  const jurisdictionApi = useJurisdictionApi();

  useEffect(() => {
    async function load() {
      setJurisdictions(await jurisdictionApi.jurisdictionGet());
    }
    load();
  }, [jurisdictionApi]);

  return jurisdictions;
}
